import { ConfirmationResponse } from "../../apis";
import { PaymentMethod, RegistrationFormValue } from "../../types";

const PREPROCESS_DEFAULT_VALUES = {
  phone: {
    prefix: "+62",
  },
  officePhone: {
    prefix: "+62",
  },
  partnerCompanyPhone: {
    prefix: "+62",
  },
  serviceFee: "4.0",
};

export const SUBMIT_STEP = 4;

/**
 *
 * @param data Partial type of ConfirmationResponse
 * @param rest rest of the data that need to be added
 * @returns RegistrationFormValue
 */

export function transformPreprocessDefaultValues(
  data: Partial<ConfirmationResponse>,
  rest: { [key: string]: any } = {}
): RegistrationFormValue {
  return {
    companyIndustry: data.corporateIndustry ?? "",
    companyName: data.corporateName ?? "",
    country: data.country ?? "",
    monthlyTravelSpending: data.monthlyTravelSpending ?? "",
    officeAddress: data.officeAddress ?? "",
    officeCity: data.officeCity ?? "",
    officePhone: {
      phone: data.officePhone ?? "",
      prefix:
        data.officePhoneCountryCode ??
        PREPROCESS_DEFAULT_VALUES.officePhone.prefix,
    },
    officePostalCode: data.officePostalCode ?? "",
    paymentMethod: data.paymentMethod ?? ("" as PaymentMethod),
    phone: {
      phone: data.picPhone ?? "",
      prefix:
        data.picPhoneCountryCode ?? PREPROCESS_DEFAULT_VALUES.phone.prefix,
    },
    picEmail: data.picEmail ?? "",
    picJobTitle: data.picJobTitle ?? "",
    picName: data.picName ?? "",
    productNeeded: data.productNeeded ?? [],
    productRequest: data.productRequest ?? [],
    website: data.website ?? "",
    preferableScheduledMeetingFirst: data.preferableScheduledMeetingFirst ?? "",
    preferableScheduledMeetingSecond:
      data.preferableScheduledMeetingSecond ?? "",
    discussionTopic: data.discussionTopic ?? "",
    locationPreference: data.locationPreference ?? "",
    ownerIdCard: data.ownerIdCard ?? "",
    ownerAddress: data.ownerAddress ?? "",
    ownerAddressCity: data.ownerAddressCity ?? "",
    ownerPostalCode: data.ownerPostalCode ?? "",
    ownerName: data.ownerName ?? "",
    ownerJobTitle: data.ownerJobTitle ?? "",
    serviceFee: data.serviceFee ?? PREPROCESS_DEFAULT_VALUES.serviceFee,
    termsOfPayment: data.termsOfPayment ?? "",
    billingCycle: data.billingCycle ?? "",
    creditLimit: data.creditLimit ?? "0",
    legalNpwpNumber: data.legalNpwpNumber ?? "",
    legalSppkpNumber: data.legalSppkpNumber ?? "",
    legalName: data.legalName ?? "",
    legalFiscalAddress: data.legalFiscalAddress ?? "",
    legalFiscalCity: data.legalFiscalCity ?? "",
    legalFiscalPostalCode: data.legalFiscalPostalCode ?? "",
    legalBillingAddress: data.legalBillingAddress ?? "",
    legalBillingCity: data.legalBillingCity ?? "",
    legalBillingPostalCode: data.legalBillingPostalCode ?? "",
    documentNotes: data.documentNotes ?? "",
    creditAssessmentNotes: data.creditAssessmentNotes ?? "",
    partnerCompanyName: data.partnerCompanyName ?? "",
    partnerCompanyRelation: data.partnerCompanyRelation ?? "",
    partnerCompanyPicName: data.partnerCompanyPicName ?? "",
    partnerCompanyPicEmail: data.partnerCompanyPicEmail ?? "",
    partnerCompanyPhone: {
      phone: data.partnerCompanyPhone ?? "",
      prefix:
        data.partnerCompanyPhoneCountryCode ??
        PREPROCESS_DEFAULT_VALUES.partnerCompanyPhone.prefix,
    },
    otherEmails: data.otherEmails ?? [],
    ...rest,
  };
}

/**
 *
 * @param step current step
 * @note step 1 never trigger handle submit so no need to check
 * @returns page position based on the step
 */
export function pageMap(step: number) {
  switch (step) {
    case 2:
      return "PAYMENT_METHOD";
    case 3:
      return "DOCUMENT";
    case 4:
      return "REVIEW";
    default:
      return "REGISTRATION_FORM";
  }
}

/**
 *
 * @param step current step
 * @note step 1 never trigger handle submit so no need to check
 * @returns tracking event name based on the step
 */

export function trackingMap(step: number) {
  switch (step) {
    case 2:
      return "SUBMIT_REGISTRATION_PAGE_3";
    case 3:
      return "SUBMIT_REGISTRATION_PAGE_4";
    case 4:
      return "SUBMIT_REGISTRATION_COMPLETE";
    default:
      return null;
  }
}
